<template>
  <ion-page class="five-page flex-column justify-between align-center">
    <ion-header class="ion-no-border">
      <div class="navbar flex-row align-center justify-between">
        <div class="nav-icon"></div>
        <span>资料选择</span>
        <img
          class="nav-icon cursor-pointer"
          :src="getBrandImageUrl('close_icon.png')"
          alt=""
          @click="onFiveClose()"
        />
      </div>
    </ion-header>
    <div class="five-page_center flex-column align-center">
      <div class="label">为你设计有针对性的资<br />料，迅速提高水平</div>
      <div class="six">
        <img class="outside-line" src="@/assets/student/version5/outside_line.svg" alt="" />
        <img class="six-center" src="@/assets/student/version5/six_center.svg" alt="" />
        <!--单词识记-->
        <img
          v-if="getCourseTypeId() !== 1"
          class="six-1"
          src="@/assets/student/version5/word_recognition.svg"
          alt=""
        />
        <img
          v-if="getCourseTypeId() === 1"
          class="six-1"
          src="@/assets/student/version5/true_word_recognition.svg"
          alt=""
          @click="openNine"
        />
        <!--语法训练-->
        <img
          v-if="getCourseTypeId() !== 2"
          class="six-2"
          src="@/assets/student/version5/grammar_test.svg"
          alt=""
        />
        <img
          v-if="getCourseTypeId() === 2"
          class="six-2"
          src="@/assets/student/version5/true_grammar_test.svg"
          alt=""
          @click="openGrammar"
        />
        <!--阅读理解-->
        <img
          v-if="getCourseTypeId() !== 3 && getCourseTypeId() !== 4"
          class="six-3"
          src="@/assets/student/version5/reading_comprehension.svg"
          alt=""
        />
        <img
          v-if="getCourseTypeId() === 3 || getCourseTypeId() === 4"
          class="six-3"
          src="@/assets/student/version5/true_reading_comprehension.svg"
          alt=""
          @click="openReading"
        />
        <!--听力训练-->
        <img
          v-if="getCourseTypeId() !== 46"
          class="six-4"
          src="@/assets/student/version5/hearing_test.svg"
          alt=""
        />
        <img
          v-if="getCourseTypeId() === 46"
          class="six-4"
          src="@/assets/student/version5/true_hearing_test.svg"
          alt=""
          @click="openGrammar"
        />
        <!--无忧写作-->
        <img
          v-if="getCourseTypeId() !== 13"
          class="six-5"
          src="@/assets/student/version5/writing_test.svg"
          alt=""
        />
        <img
          v-if="getCourseTypeId() === 13"
          class="six-5"
          src="@/assets/student/version5/true_writing_test.svg"
          alt=""
          @click="openGrammar"
        />
        <!--词汇测试-->
        <img
          class="six-6"
          src="@/assets/student/version5/true_vocabulary_test.svg"
          alt=""
          @click="openVocabularyTest"
        />
      </div>
    </div>
    <div class="bottom-logo">
      <!--      <img src="@/assets/student/version5/bottom_logo.svg" alt="" />-->
    </div>
  </ion-page>
</template>

<script>
import { IonHeader, IonPage, modalController } from "@ionic/vue"

import { closeOutline } from "ionicons/icons"
import pagesQueue from "@/js/pagesQueue"
import GrammarIndex from "@/views/grammar/Index"
import ReadingIndex from "@/views/reading/Index"
import { BRAND_IMAGES, getBrandImageUrl } from "@/js/brandImages.ts"
import mqttServer from "@/js/mqtt"
import http from "@/js/http"

export default {
  name: "SpeedIndex",
  components: {
    IonHeader,
    IonPage,
  },
  props: ["studentId", "courseId"],

  setup() {
    return {
      closeOutline,
    }
  },

  data() {
    return {
      instructData: {
        project: "lxll",
        page: "teachIndex",
        module: "Five",
        pageModle: true,

        userType: 1,
        data: null,
        fn: "",
        param: null,
        timestamp: " ",
      },
      clockTimer1: undefined,
      clockTimer2: undefined,
      remainingTime: undefined, //剩余时间
      isReminded: false, //是否提醒过
      isFinished: false, //是否结束
      appointment: {},
      brandImages: BRAND_IMAGES,
    }
  },

  mounted() {
    // sessionStorage.setItem('pageFlag','false')
    this.userinfo = this.store.getUser()
    this.appointment = this.store.getAppointment()
    mqttServer.onMqttMessage(this.instructData.module, this.onMessageReceived)
    sessionStorage.setItem("pageFlag", "true")

    /*    this.readRemainingTime();
    this.startTimer();*/
  },

  methods: {
    async onMessageReceived(msg) {
      // 确保 msg.fn 是 this 上的有效函数
      if (typeof this[msg.fn] !== "function") {
        throw new Error(`Method ${msg.fn} is not a function`)
      }

      try {
        // 根据 params 是否为数组决定如何调用方法
        if (Array.isArray(msg.params)) {
          await this[msg.fn](...msg.params)
        } else {
          await this[msg.fn](msg.params)
        }
        return true
      } catch (error) {
        console.error("Error executing method:", error)
        throw error // 或者根据需要处理错误
      }
    },

    // 关闭5滴图
    async onFiveClose() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "onFiveCloseSync",
          msgType: "function",
        })
        .then(async () => {
          this.onFiveCloseSync()
        })
    },
    async onFiveCloseSync() {
      pagesQueue.queuePagePop()
      /*      clearInterval(this.clockTimer1);
            clearInterval(this.clockTimer2);*/
      await modalController.dismiss()
      // this.$router.replace("/TeacherIndex")
    },
    handleStartTimer() {
      //如果正在学习单词，则转向训后检测，否则直接回到首页
      if (this.store.getAfterTestFlag() == "AFTER_TEST") {
        location.replace("/speedVideo/AfterTest/" + this.currentStudentId)
      }

      //没有需要提交的单词则直接返回到首页
      else {
        location.replace("/TeacherIndex")
      }
    },

    getBrandImageUrl,
    /**
     * @param this.getCourseTypeId - 练习课练习类型 1 单词速记 2 语法 3 阅读理解和完型
     * @param this.appointment.classification - 资料类型 3 体验课 2 60分钟 1 30分钟
     * */
    async openNine() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "openNineBySync",
          msgType: "function",
        })
        .then(async () => {
          this.openNineBySync()
        })
    },

    async openNineBySync() {
      if (this.getCourseTypeId() != 1 && this.appointment.classification != 3) {
        return
      }
      pagesQueue.queuePagePush({
        page: "Nine",
        params: {
          studentId: this.studentId,
          eventCount: this.eventCount,
        },
      })
      // const modal = await modalController.create({
      //   component: Nine,
      //   componentProps: {
      //     studentId: this.studentId,
      //     eventCount: this.eventCount,
      //   },
      //   cssClass: "modal_controller_class modal_controller_class_Nine",
      //   htmlAttributes: this.eventCount,
      // })
      sessionStorage.setItem("pageFlag", "false")

      // return modal.present()
    },

    // 打开词汇量测试
    async openVocabularyTest() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "openVocabularyTestSync",
          msgType: "function",
        })
        .then(() => {
          this.openVocabularyTestSync()
        })
    },

    async openVocabularyTestSync() {
      this.ajax
        .get("/vocabulary/createVocabularyTest?userId=" + this.studentId)
        .then(async (res) => {
          if (res.data.success) {
            pagesQueue.queuePagePush({
              page: "VocabularyTest",
              params: {
                testId: res.data.data.testId,
                testUserId: this.studentId,
              },
            })
            // const modal = await modalController.create({
            //   component: VocabularyTest,
            //   componentProps: {
            //     testId: res.data.data.testId,
            //     testUserId: this.studentId,
            //   },
            //   cssClass: "modal_controller_class",
            // })
            // return modal.present()
          }
        })
    },

    //打开语法练习页面
    async openGrammar() {
      /* if (this.getCourseTypeId() != 2) {
        return;
      }*/
      const modal = await modalController.create({
        component: GrammarIndex,
        componentProps: { studentId: this.studentId },
        cssClass: "modal_controller_class",
      })
      return modal.present()
    },

    //打开阅读理解页面
    async openReading() {
      const modal = await modalController.create({
        component: ReadingIndex,
        componentProps: { studentId: this.studentId, courseId: this.courseId },
        cssClass: "modal_controller_class",
      })
      return modal.present()
    },

    routerBack() {
      modalController.dismiss()
    },

    // onFiveClose() {
    //   clearInterval(this.clockTimer1);
    //   clearInterval(this.clockTimer2);
    //   modalController.dismiss();
    // },

    startTimer() {
      const time = setTimeout(() => {
        // 定时器1 用于读秒，到时提醒
        this.clockTimer1 = setInterval(async () => {
          //如果正在进行训后检测，则不进行强制结束
          if (!this.pageAfterTestIsOpen) {
            if (this.remainingTime <= 0 && this.isFinished == false) {
              this.isFinished = true
              setTimeout(() => {
                const appointment = this.store.getAppointment()
                http
                  .post(
                    `/record/endClass?aptmId=${appointment.aptmId}&flag=0`,
                    {},
                    "",
                    "",
                    "",
                    3000,
                    true
                  )
                  .then((res) => {
                    if (res.data.success) {
                      setTimeout(() => {
                        sessionStorage.setItem("roomStatus", 4)
                      }, 1000)
                      //如果正在学习单词，则转向训后检测，否则直接回到首页
                      if (this.store.getAfterTestFlag() == "AFTER_TEST") {
                        location.replace("/AfterTest/" + this.currentStudentId)
                      }

                      //没有需要提交的单词则直接返回到首页
                      else {
                        location.replace("/TeacherIndex")
                      }
                    }
                  })
              }, 3000)
              await this.alert(this.$t("练习结束"), () => {
                sessionStorage.setItem("roomStatus", 4)
                location.replace("/TeacherIndex")
              })
            } else if (this.remainingTime > 0) {
              if (this.remainingTime <= 300 && this.isReminded == false) {
                this.isReminded = true
                this.audio(this.voice_path + "clock.mp3")
                this.alert(this.$t("本次资料倒计时5分钟，请尽快完成训后检测，并提交结果！"))
              }
            }
          }

          if (this.remainingTime) {
            this.remainingTime--
          }
        }, 1000)

        //定时器2 同步资料剩余时间，1分钟一次
        this.clockTimer2 = setInterval(() => {
          this.readRemainingTime()
        }, 1000 * 60)
        clearTimeout(time)
      }, 1000 * 60)
    },

    getCourseTypeId() {
      let courseTypeId = 1
      const appointment = this.store.getAppointment()
      if (appointment && appointment.courseTypeId) {
        //课程类型没获取到
        courseTypeId = appointment.courseTypeId
      }
      return courseTypeId
    },

    styleBackground() {
      if (this.appointment.classification == 3) {
        return "startnew startnew_background1"
      }

      return "startnew startnew_background" + this.getCourseTypeId()
    },

    //同步剩余时间
    readRemainingTime() {
      const appointment = this.store.getAppointment()
      if (!appointment.aptmId) return
      if (appointment != null) {
        this.ajax.get("/record/readRemainingTime?aptmId=" + appointment.aptmId).then((res) => {
          if (res.data.success) {
            console.log("同步了剩余时间：" + res.data.time)
            this.remainingTime = res.data.time
          }
        })
      }
    },
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.five-page {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: linear-gradient(180deg, #dcf8ef 0%, #f2f3f7 30%);

  .navbar {
    width: 100%;
    height: 5rem;
    text-align: center;
    position: relative;
    font-size: 1rem;
    font-weight: 600;
    padding: 0 1rem;

    .nav-icon {
      width: 1.2rem;
    }
  }

  .bottom-logo {
    width: 70%;
    height: 3rem;

    img {
      width: 100%;
    }
  }

  &_center {
    padding-bottom: 8rem;

    .label {
      font-size: 1.1rem;
      color: #606266;
      line-height: 1.5rem;
      text-align: center;
    }

    .six {
      margin-top: 5rem;
      width: 22rem;
      height: 22rem;
      position: relative;

      .outside-line {
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 1;
      }

      .six-center {
        position: absolute;
        top: 49%;
        left: 51%;
        transform: translate(-50%, -50%);
        width: 40%;
        z-index: 2;
      }

      &-1 {
        position: absolute;
        left: 52%;
        top: 4%;
        width: 7.6rem;
        z-index: 3;
      }

      &-2 {
        position: absolute;
        left: 72%;
        top: 28%;
        width: 5.3rem;
        z-index: 3;
      }

      &-3 {
        position: absolute;
        left: 54%;
        top: 63%;
        width: 7.6rem;
        z-index: 3;
      }

      &-4 {
        position: absolute;
        left: 16%;
        top: 66%;
        width: 7.6rem;
        z-index: 3;
      }

      &-5 {
        position: absolute;
        left: 5%;
        top: 34%;
        width: 5.3rem;
        z-index: 3;
      }

      &-6 {
        position: absolute;
        left: 12%;
        top: 5%;
        width: 7.6rem;
        z-index: 3;
      }
    }
  }
}
</style>
